// api
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api-stage.consulty.online";

export const userProfileUrl = "https://consulty.online/app/expert/";
